import { environment } from "./../../../../environments/environment";
import { catchError } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { HttpClient } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler
} from "./../../../util/http-error-handler.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import RelatorioFaturamentoCartaoFidelidadeFiltro from "../../../models/relatorio-faturamento-cartao-fidelidade/relatorio-faturamento-cartao-fideliade-filtro.model";
import RelatorioPontuacaoFuncionaraioFiltro from "../../../models/relatorio-pontuacao-funcionario/relatorio-pontuacao-funcionario-filtro.model";

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: "root"
})
export class RelatorioPontuacaoFuncionarioService {
  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError("RelatorioClienteRecorrenteService");
  }

  obterTodos(param: any, direcao: string, propriedade: string, parametro: RelatorioPontuacaoFuncionaraioFiltro): Observable<any> {
    const params = new HttpParams()
      .set('Direcao', `${(direcao)}`)
      .set('Propriedade', `${(propriedade)}`)
      .set("pageNumber", `${param.offset}`)
      .set('startDate', `${parametro.startDate == null ? null : parametro.startDate.toString()}`)
      .set('endDate', `${parametro.endDate == null ? null : parametro.endDate.toString()}`)
      .set("pageSize", `${param.limit}`);

    return this.http
      .get<any>(`${API_URL}/v1/employeescoresreport`, { params })
      .pipe(catchError(this.handleError("obter-todas", [])));
  }
}
